import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CategoryView from '../views/CategoryView.vue'
import BetanoMagView from '../layouts/BetanoMagPost.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        children: [
            {
                path: "/video/:video_id/",
                name: 'home_video',
                props: true,
                component: () => import('../components/VideoComponent.vue'),
                meta: {
                    stopScroll: true
                },
            }
        ],
    },
    {
        path: '/:slug',
        name: 'post',
        props: true,
        component: () => import('../views/SlugView.vue'),
        children: [
            {
                path: ':slugs+',
                name: 'subSlug',
                props: true,
                component: () => import('../views/SlugsSubView.vue'),
                meta: {
                    stopScroll: true
                },
            },
        ],
    },
    {
        path: '/preview/:id',
        name: 'preview',
        props: true,
        component: () => import('../views/PreviewView.vue'),
    },
    {
        path: '/betano-mag/:slug',
        name: 'betano-mag',
        component: BetanoMagView,
        props: true,
    },
    {
        path: '/category/:slugs+',
        name: 'category',
        component: CategoryView,
        props: true,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from /*, savedPosition */) {
        if (to.path == from.path) {
            return
        }
        if (to.meta.stopScroll || from.meta.stopScroll) {
            return
        }
        return { top: 0 }
    },
})

router.beforeEach((to, from) => {
    console.log("ROUTER TO", to)
    console.log("ROUTER FROM", from)
    if (to.query.p) {
        console.log("ROUTER QUERY", to.query)
        return { name: 'preview', params: { id: to.query.p } }
    }
})

export default router

// https://blog.betano.pt/category/autores-betano/betanomag/
